import { useAppSelector } from '@online-webinar/store';
import { LabelHeading } from '../..';

export const BroadcastViewerCount = () => {
    const totalViewers = useAppSelector((state) => state.liveWebinar.onlineParticipants);
    return (
        <div className="flex flex-col justify-center px-2 md:px-5">
            <LabelHeading name="Viewer" />
            <div className="font-medium font-accent text-xl leading-tight">{totalViewers}</div>
        </div>
    );
};
